"use strict";

import $ from 'jquery';
require("jquery-ui/ui/widgets/resizable");
require("jquery-ui/ui/effect");
import toastr from 'toastr';
import bootstrapMenu from 'bootstrap-menu';
import 'bootstrap-datepicker';
import bootstrapDialog from './modules/bootstrap4-dialog';
import 'admin-lte';
global.$ = global.jQuery = $;
global.toastr = toastr;
global.BootstrapMenu = bootstrapMenu;
global.BootstrapDialog = bootstrapDialog;
// import '../node_modules/bootstrap-icons/font/bootstrap-icons.css';
require('bootstrap-datepicker/js/locales/bootstrap-datepicker.de.js');
require('magnific-popup');
import AOS from 'aos';
global.AOS = AOS;

const dayjs = require('dayjs');
require('dayjs/locale/de');
dayjs.locale('de');
global.dayjs = dayjs;
global.moment = dayjs;

import "../node_modules/vanilla-cookieconsent/dist/cookieconsent.css";
import '../node_modules/vanilla-cookieconsent/dist/cookieconsent';
require('./js/init-cookiebanner');

require('./modules/ddslick/ddslick.js');
require('./modules/autocompleter/autocompleter.js');
require('./modules/isloading/jquery.isloading.js');
require('./js/pwa.js');
require('./js/forms.js');
require('./js/general.js');
require('./js/domhelper.js');
require('./js/class.messaging.js');
require('./js/class.dropzone.js');
require('./js/class.documents.js');
require('./js/class.contextmenu.js');
require('./js/class.notification.js');
require('./js/class.connection.js');
require('./js/class.slidein.js');
require('./js/class.navtabs.js');
require('./js/class.progress.js');
require('./js/class.taskQueue.js');
require('./js/guid.js');
require('./js/countdown.js');

require('./js/public.js');
import '../node_modules/aos/dist/aos.css';

import JsBase from "./jsbase/jsbase";

import Select from "./jsbase-components/select";
JsBase.register('form-select', Select);

$(document).on('content-ready', function(ev, data) {
    $(data[0]).find('select.form-control').attr('data-form-select', 'select');
    JsBase.initAll(data[0]);
});